<template>
  <div>
    <Teleport to="body" :disabled="!teleport">
      <div :class="`tray ${wrapClass}`" ref="tray" :style="{ zIndex: zIndex }">
        <div
          v-if="title"
          class="d-flex justify-content-between align-items-center"
          :class="`${wrapClass ? wrapClass + '-close' : ''}`"
        >
          <h2 class="mb-0">{{ title }}</h2>
          <button
            class="close text-dark"
            style="font-size: 40px"
            @click="close"
          >
            &times;
          </button>
        </div>
        <button
          v-else
          :class="`close mt-4 mr-4 text-dark ${
            wrapClass ? wrapClass + '-close' : ''
          }`"
          style="font-size: 40px"
          @click="close"
        >
          &times;
        </button>
        <div :class="`tray-body ${wrapClass ? wrapClass + '-body' : ''}`">
          <slot></slot>
        </div>
      </div>
      <div
        :class="`tray-bg ${wrapClass ? wrapClass + '-body' : ''}`"
        ref="tray-bg"
      >
        &nbsp;
      </div>
    </Teleport>
    <div
      :class="`tray-bg ${wrapClass ? wrapClass + '-body' : ''}`"
      ref="tray-bg"
      @click="close"
    >
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  props: {
    toggle: {
      type: Boolean,
      default: false,
    },
    wrapClass: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    teleport: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 2000,
    },
    lockBodyScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollTop: 0,
      bodyWasLockedByThis: false,
    };
  },
  watch: {
    toggle: function (value) {
      if (value) {
        this.$refs["tray"].classList.add("open");
        this.$refs["tray-bg"].classList.add("open");

        if (this.lockBodyScroll) {
          this.lockPageScroll();
        }
      } else {
        this.$refs["tray"].classList.remove("open");
        this.$refs["tray-bg"].classList.remove("open");

        if (this.lockBodyScroll) {
          this.unlockPageScroll();
        }
      }
    },
  },
  mounted() {
    let vm = this;
    vm.$refs["tray"].addEventListener("transitionstart", function (e) {
      if (e.target.classList.contains("open")) {
        vm.$refs["tray-bg"].style.zIndex = vm.zIndex - 5;
      }
    });
    vm.$refs["tray"].addEventListener("transitionend", function (e) {
      if (!e.target.classList.contains("open") && !vm.toggle) {
        vm.$refs["tray-bg"].style.zIndex = -1;
      }
    });

    if (this.toggle && this.lockBodyScroll) {
      this.lockPageScroll();
    }
  },

  beforeDestroy() {
    if (this.lockBodyScroll) {
      this.unlockPageScroll();
    }
  },
  methods: {
    close: function () {
      this.$emit("close");
    },

    lockPageScroll() {
      if (this.bodyWasLockedByThis) return;

      this.scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || 0;

      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollTop}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";

      this.bodyWasLockedByThis = true;
    },

    unlockPageScroll() {
      if (!this.bodyWasLockedByThis) return;

      const top = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";

      this.bodyWasLockedByThis = false;

      if (top) {
        window.scrollTo(0, Math.abs(parseInt(top, 10)) || 0);
      }
    },
  },
};
</script>
<style lang="scss">
.tray.open {
  right: 0px !important;
  max-width: 100%;
}
.tray {
  background-color: rgba(245, 245, 245, 1);
  height: 100%;
  width: 600px;
  overflow-x: hidden;
  position: fixed;
  top: 0px;
  right: -630px;
  z-index: 2000;
  transition: right 0.3s ease-in-out;
  &.open {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  }

  .tray-body {
    padding: 20px;
  }
}

.tray-bg {
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}

.tray-bg.open {
  opacity: 1;
  pointer-events: auto;
}
</style>
